export { default } from './FaqsSection'
